// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2XqA7","rootSuccess":"CompleteLink_rootSuccess__1Ch97","rootFailure":"CompleteLink_rootFailure__1_5xr","isDisabled":"CompleteLink_isDisabled__2-VKS"};